export default {
  PERFORM_DEPOSIT_ACTION: "actionHandler/PERFORM_DEPOSIT_ACTION",
  OPEN_POKER_GAME: "actionHandler/OPEN_POKER_GAME",
  OPEN_POKER_HISTORY: "actionHandler/OPEN_POKER_HISTORY"
};
